import { ia, iaRa } from 'lib/helpers/utility';

// A filter being added has an entry before it has a value; `withValues` counts only picked values.
export const hasActiveFilters = (filters, { withValues = false } = {}) =>
  Object.values(filters || {}).some((entries) =>
    withValues ? iaRa(entries).some((entry) => ia(entry?.values)) : ia(entries)
  );
